// import API from '@aws-amplify/api'
import API, { graphqlOperation } from "@aws-amplify/api";
import { Auth } from "aws-amplify";
import { listRedmineConfigs, snsPublish } from "../graphql/queries";
import { createRedmineConfig, deleteRedmineConfig } from "../graphql/mutations";

export const SET_PAGETITLE = "SET_PAGETITLE";
export const SET_AUTH_CURRENT_USER = "SET_AUTH_CURRENT_USER";

export const READ_PROJECTS = "READ_PROJECTS";
export const READ_PROJECT_DETAIL = "READ_PROJECT_DETAIL";
export const RESET_PROJECTS = "RESET_PROJECTS";
export const RESET_PROJECT_DETAIL = "RESET_PROJECT_DETAIL";

// export const CREATE_PROJECT = 'CREATE_PROJECT'
// export const UPDATE_PROJECT = 'UPDATE_PROJECT'
// export const DELETE_PROJECT = 'DELETE_PROJECT'

export const READ_ISSUES = "READ_ISSUES";
export const CREATE_ISSUE = "CREATE_ISSUE";
export const UPDATE_ISSUES = "UPDATE_ISSUES";
export const DELETE_ISSUE = "DELETE_ISSUE";
export const RESET_ISSUES = "RESET_ISSUES";

export const READ_ISSUE_DETAIL = "READ_ISSUE_DETAIL";
// export const CREATE_ISSUE_DETAIL = 'CREATE_ISSUE_DETAIL'
export const UPDATE_ISSUE_DETAIL = "UPDATE_ISSUE_DETAIL";
export const ADD_ISSUE_NOTE = "ADD_ISSUE_NOTE";
// export const DELETE_ISSUE_DETAIL = 'DELETE_ISSUE_DETAIL'
export const RESET_ISSUE_DETAIL = "RESET_ISSUE_DETAIL";

export const SET_REDMINE = "SET_REDMINE";
export const SET_PROJECT = "SET_PROJECT";
export const SET_USER = "SET_USER";
export const SET_PROJECT_MEMBERSHIPS = "SET_PROJECT_MEMBERSHIPS";
export const SET_ISSUE_STATUSES = "SET_ISSUE_STATUSES";
export const SET_ISSUE_FILTER = "SET_ISSUE_FILTER";
export const RESET_CURRENT = "RESET_CURRENT";

export const READ_CONFIGS = "READ_CONFIGS";
export const CREATE_CONFIG = "CREATE_CONFIG";
export const DELETE_CONFIG = "DELETE_CONFIG";
export const UPDATE_CONFIG = "UPDATE_CONFIG";

export const READ_SEARCH = "READ_SEARCH";
export const RESET_SEARCH = "RESET_SEARCH";
export const SET_SEARCH_WORD = "SET_SEARCH_WORD";

export const SET_EDIT_CONFIG = "SET_EDIT_CONFIG";
export const UPDATE_EDIT_CONFIG = "UPDATE_EDIT_CONFIG";
export const RESET_EDIT_CONFIG = "RESET_EDIT_CONFIG";

export const GET_USER = "GET_USER";
export const RESET_USERS = "RESET_USERS";

const apiName = "redmineProxyApi";
const path = "/v1/redmine/proxy";

export const ApiName = "redmineProxyApi";
export const RedminePath = "/v1/redmine/proxy";

///////////////////////////////////////////////////////////////////////
// RedmineConfig
///////////////////////////////////////////////////////////////////////
export const getUserInfo = async (dispatch) => {
  const user = await Auth.currentUserInfo();
  const apikey = user.attributes["custom:apikey"];
  const redmineurl = user.attributes["custom:redmineurl"];

  const redmineinfo = { apikey, redmineurl };
  dispatch({ type: SET_REDMINE, redmineinfo });
};

export const setRedmine = async (dispatch, redmineConf) => {
  const { redmineinfo, user } = await getRedmineInfo(redmineConf);
  const resetStateList = [
    RESET_CURRENT,
    RESET_PROJECTS,
    RESET_PROJECT_DETAIL,
    RESET_ISSUES,
    RESET_ISSUE_DETAIL,
    RESET_SEARCH,
    RESET_EDIT_CONFIG,
    RESET_USERS,
  ];
  resetStateList.forEach((resetState) => dispatch({ type: resetState }));

  dispatch({ type: SET_REDMINE, redmineinfo, user });
};

export const updateRedmine = async (dispatch, redmineConf) => {
  const { redmineinfo, user } = await getRedmineInfo(redmineConf);
  dispatch({ type: SET_REDMINE, redmineinfo, user });
};

export const setProject = async (dispatch, project) => {
  // const projectid = {project: project}
  dispatch({ type: SET_PROJECT, project });
};
export const fetchUser = async (apiKey, redmineUrl) => {
  // const projectid = {project: project}
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "users/current.json",
      url: redmineUrl,
    },
  };
  const response = await API.get(apiName, path, myInit);
  // console.log('user: ', response)
  return response;
  // dispatch({type: SET_USER, project})
};

const getRedmineInfo = async (redmineConf) => {
  const { id, name, apikey, redmineurl } = redmineConf;
  const redmineinfo = { id, name, apikey, redmineurl };
  const res = await fetchUser(apikey, redmineurl);
  const user = res.success.user;
  return { redmineinfo, user };
};

///////////////////////////////////////////////////////////////////////
// EditRedmineConfig
///////////////////////////////////////////////////////////////////////
export const setEditConfig = (dispatch, config) => {
  dispatch({ type: SET_EDIT_CONFIG, config });
};

export const updateEditConfig = (dispatch, config) => {
  dispatch({ type: UPDATE_EDIT_CONFIG, config });
};

export const resetEditConfig = (dispatch) => {
  dispatch({ type: RESET_EDIT_CONFIG });
};

///////////////////////////////////////////////////////////////////////
// Project
///////////////////////////////////////////////////////////////////////
export const readProjects = async (redmineUrl, apiKey, dispatch) => {
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "projects.json",
      url: redmineUrl,
    },
  };
  // console.log('myInit: ', myInit)
  const response = await API.get(apiName, path, myInit);
  // console.log('projects: ', response)
  dispatch({ type: READ_PROJECTS, response });
};
export const readProjectDetail = async (redmineUrl, apiKey, id, dispatch) => {
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "projects/" + id + ".json",
      url: redmineUrl,
    },
  };
  const response = await API.get(apiName, path, myInit);
  // console.log('projects: ', response)
  dispatch({ type: READ_PROJECT_DETAIL, response });
};
export const fetchProjectMemberships = async (
  redmineUrl,
  apiKey,
  id,
  dispatch
) => {
  if (!redmineUrl) return;
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "projects/" + id + "/memberships.json",
      url: redmineUrl,
    },
  };
  const response = await API.get(apiName, path, myInit);
  // console.log('projectMemberships: ', response)
  // return response
  const memberships = response.success.memberships;
  setProjectMemberships(dispatch, memberships);
};

export const setProjectMemberships = async (dispatch, memberships) => {
  dispatch({ type: SET_PROJECT_MEMBERSHIPS, memberships });
};

///////////////////////////////////////////////////////////////////////
// Issue
///////////////////////////////////////////////////////////////////////
export const readIssues = async (redmineUrl, apiKey, conditions, dispatch) => {
  let query = "";
  if (conditions.projectid) {
    query = `?project_id=${conditions.projectid}`;
  }
  if (conditions.query) {
    query = conditions.query;
  }
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "issues.json" + query,
      url: redmineUrl,
    },
  };
  const response = await API.get(apiName, path, myInit);
  // console.log('issues: ', response)
  dispatch({ type: READ_ISSUES, response });
  return response;
};

export const readissueDetail = async (
  redmineUrl,
  apiKey,
  conditions,
  dispatch
) => {
  const id = conditions.id;
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "issues/" + id + ".json?include=journals,allowed_statuses",
      url: redmineUrl,
    },
  };
  // console.log('myInt: ', myInit)

  const response = await API.get(apiName, path, myInit);
  // console.log('issues: ', response)
  dispatch({ type: READ_ISSUE_DETAIL, response });
};

export const createIssue = async (redmineUrl, apiKey, dispatch, body) => {
  const myInit = {
    body,
    headers: {
      // 'Content-type': 'application/json',
      "X-Api-Key": apiKey,
    },
    queryStringParameters: {
      path: "issues.json",
      url: redmineUrl,
    },
  };
  // console.log('create issue obj: ', myInit)

  const response = await API.post(apiName, path, myInit);
  let data;
  if (response.success) {
    data = JSON.parse(response.success);
    // console.log('create response: ', data)
    dispatch({ type: CREATE_ISSUE, data });
  } else if (response.error) {
    data = JSON.parse(response.error);
    // console.log('create error: ', data)
  }

  return data;
};

export const updateIssue = async (redmineUrl, apiKey, dispatch, id, body) => {
  let post_body = { ...body };
  // console.log("body_def: ", body);
  post_body.issue.status_id = body.issue.status.id;
  // console.log("post_body1: ", post_body);
  // delete post_body.issue.status
  // console.log('post_body2: ', post_body)
  // status_id = status.id
  const myInit = {
    body: post_body,
    headers: {
      // 'Content-type': 'application/json',
      "X-Api-Key": apiKey,
    },
    queryStringParameters: {
      path: "issues/" + id + ".json",
      url: redmineUrl,
    },
  };
  // console.log('myInit: ', myInit)

  const response = await API.put(apiName, path, myInit);
  if (response.success.statuscode === 204) {
    const result = body;
    // console.log('result: ', result)
    dispatch({ type: UPDATE_ISSUE_DETAIL, result });
  }
  // const data = JSON.parse(response.success)
  // console.log('create issue obj: ', data)
  // console.log('body: ', body)
  // delete result.project_id
  // dispatch({type: UPDATE_ISSUE_DETAIL, result})
};
export const addIssueNote = async (
  redmineUrl,
  apiKey,
  dispatch,
  id,
  body,
  currentUser
) => {
  const myInit = {
    body,
    headers: {
      // 'Content-type': 'application/json',
      "X-Api-Key": apiKey,
    },
    queryStringParameters: {
      path: "issues/" + id + ".json",
      url: redmineUrl,
    },
  };
  const response = await API.put(apiName, path, myInit);

  if (response.success.statuscode === 204) {
    const user = {
      id: currentUser.id,
      name: currentUser.lastname + " " + currentUser.firstname,
    };
    // console.log('response: ', response)
    // const result = body
    const result = {
      notes: body.issue.notes,
      user,
    };
    dispatch({ type: ADD_ISSUE_NOTE, result });
  }
};

export const deleteIssue = async (redmineUrl, apiKey, dispatch, id) => {
  const myInit = {
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    },
    queryStringParameters: {
      path: "issues/" + id + ".json",
      url: redmineUrl,
    },
  };

  const response = await API.del(apiName, path, myInit);
  dispatch({ type: DELETE_ISSUE, response });
};

///////////////////////////////////////////////////////////////////////
// Setting
///////////////////////////////////////////////////////////////////////
export const readStatus = async (redmineUrl, apiKey, dispatch) => {
  if (!redmineUrl) return;
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "issue_statuses.json",
      url: redmineUrl,
    },
  };
  // console.log('myInt: ', myInit)

  const response = await API.get(apiName, path, myInit);
  // console.log('issues: ', response)
  return response.success.issue_statuses;
  // dispatch({type: READ_ISSUE_DETAIL, response})
};

///////////////////////////////////////////////////////////////////////
// Issue Statuses
///////////////////////////////////////////////////////////////////////
export const fetchIssueStatuses = async (redmineUrl, apiKey, dispatch) => {
  if (!redmineUrl) return;
  const myInit = {
    // OPTIONAL
    headers: {
      "Content-type": "application/json",
      "X-Api-Key": apiKey,
    }, // OPTIONAL
    queryStringParameters: {
      path: "issue_statuses.json",
      url: redmineUrl,
    },
  };
  // console.log('myInit: ', myInit)
  const response = await API.get(apiName, path, myInit);
  // console.log('issue statuses: ', response)
  const issue_statuses = response.success.issue_statuses;
  dispatch({ type: SET_ISSUE_STATUSES, issue_statuses });
};

///////////////////////////////////////////////////////////////////////
// Issue Filter
///////////////////////////////////////////////////////////////////////
export const setIssueFilter = async (dispatch, filter) => {
  dispatch({ type: SET_ISSUE_FILTER, filter });
};

///////////////////////////////////////////////////////////////////////
// Delete Account
///////////////////////////////////////////////////////////////////////
export const deleteAccount = async (values) => {
  try {
    return await API.graphql(graphqlOperation(snsPublish, values));
  } catch (err) {
    return err;
  }
};

///////////////////////////////////////////////////////////////////////
// Navbar
///////////////////////////////////////////////////////////////////////
export const setPageTitle = async (dispatch, title) => {
  dispatch({ type: SET_PAGETITLE, title });
};

export const setAuthCurrentUser = async (dispatch, username) => {
  dispatch({ type: SET_AUTH_CURRENT_USER, username });
};
